import type { UserProfile } from 'store/users/types'

import { AgentBadge } from '@rentspree/component-v2/dist/agent-badge'

import { Affix } from 'components'
import { ApplyPanel } from 'containers/public-listing/apply-panel'
import { Panel } from 'containers/public-listing/styled'
import { useSelector } from 'store'
import { selectIsContactModalOpen } from 'store/public-listing'
import { COLOR } from 'styles/constants'

interface ListingApplyPanelDesktopProps {
  isPreview?: boolean
  agentContact: AgentContact
  handleAgentInfoClick: () => void
  handleApply: () => void
  offset: number
  handleContactClick: () => void
  profile?: UserProfile
}

export const ListingApplyPanelDesktop = ({
  agentContact,
  handleAgentInfoClick,
  handleApply,
  offset,
  isPreview,
  handleContactClick,
  profile,
}: ListingApplyPanelDesktopProps) => {
  const isContactModalOpen = useSelector(selectIsContactModalOpen)

  const handleClickAgentBadge = (e: React.MouseEvent) => {
    e.preventDefault()
    handleAgentInfoClick?.()
  }

  const handleClickApplyButton = (e: React.MouseEvent) => {
    e.preventDefault()

    if (!isPreview) {
      handleApply?.()
    }
  }

  const handleClickContact = (e: React.MouseEvent) => {
    e.preventDefault()

    if (!isPreview) {
      handleContactClick?.()
    }
  }

  const isAgentBadgeClickable = !isPreview && agentContact.slug

  return (
    <Panel width="280px" margin="0 0 0 50px" zIndex={isContactModalOpen ? '12' : '1'}>
      <AgentBadge
        type="secondary"
        onClick={isAgentBadgeClickable ? handleClickAgentBadge : undefined}
        id="agentProfileDesktop"
        {...agentContact}
        titleSize="16px"
        subTitleSize="14px"
        titleLineHeight="28px"
        subTitleLineHeight="24px"
        titleWeight="700"
        subTitleWeight="700"
        titleColor={isAgentBadgeClickable ? COLOR.BLUE_LV2 : COLOR.GREY_LV1}
        titleHoverColor={isAgentBadgeClickable ? COLOR.BLUE_LV4 : COLOR.GREY_LV1}
      />
      <Affix offset={offset} scrollableAreaSelector="#listing-info">
        <ApplyPanel
          $mt={20}
          $mb={30}
          onApplyClick={handleClickApplyButton}
          onContactClick={handleClickContact}
          contactButtonId="contactButtonDesktop"
          applyButtonId="applyButtonDesktop"
          isPreview={isPreview}
          profile={profile}
        />
      </Affix>
    </Panel>
  )
}
ListingApplyPanelDesktop.defaultProps = {
  isPreview: false,
  profile: {},
}
